import React__default, { forwardRef } from 'react';
import { Button } from 'reactstrap';
import DateDisplay from '../../UI/DateDisplay/DateDisplay.js';
import { Nbsp } from '../../UI/Nbsp.js';
import { FontAwesomeIcon } from '../../../../../../../node_modules/.pnpm/@fortawesome_react-fontawesome@0.2.2_@fortawesome_fontawesome-svg-core@6.7.2_react@19.0.0/node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faCalendarAlt } from '../../../../../../../node_modules/.pnpm/@fortawesome_free-solid-svg-icons@6.7.2/node_modules/@fortawesome/free-solid-svg-icons/index.mjs.js';

const CustomDateDisplayInner = (props, ref) => {
    const { onClick, date, format, placeholder, dataTestId, className } = props;
    return (React__default.createElement(Button, { className: `iso__date-range-input custom-button ${className || ''}`, color: "white", onClick: onClick, ref: ref, "data-testid": dataTestId },
        React__default.createElement("div", { className: "d-flex" },
            date ? (React__default.createElement("div", { className: "w-100" },
                React__default.createElement(DateDisplay, { date: date.toISOString(), format: format }))) : (React__default.createElement(Nbsp, null)),
            props.theme?.useCalenderIcon && (React__default.createElement("div", { className: "ml-auto" },
                React__default.createElement(FontAwesomeIcon, { icon: faCalendarAlt }))),
            !date && placeholder ? (React__default.createElement("div", { className: "w-100 text-left text-muted" }, placeholder)) : (React__default.createElement(Nbsp, null)))));
};
const CustomDateDisplay = forwardRef(CustomDateDisplayInner);

export { CustomDateDisplay };
//# sourceMappingURL=CustomDateDisplay.js.map
